class SwiperComponent extends HTMLElement {
    constructor() {
        super();
        this.swipers = this.querySelectorAll('swiper-container');
        this.swiperInstances = [];
    }

    connectedCallback() {
        this.swipers.forEach(swiper => {
            this._initSwiper(swiper);
        });

        $(document).on('quick-buy-popover:change:end', e => {
            this.swipers.forEach(swiper => {
                this._initSwiper(swiper);
            });
        });

        window.addEventListener('resize', () => {
            this._handleResize();
        });
    }

    _initSwiper(swiper) {
        const isMobileOnly = swiper.classList.contains('mobile-only');
        if (isMobileOnly) {
            if (window.innerWidth <= 768 && !swiper.swiperInstance) {
                swiper.swiperInstance = new Swiper(swiper, {
                    slidesPerView: swiper.getAttribute('slides-per-view') || 1,
                    loop: true,
                    navigation: {
                        nextEl: '.swiper-button-next',
                        prevEl: '.swiper-button-prev',
                    },
                    pagination: {
                        el: '.swiper-pagination',
                        clickable: true,
                    },
                });
                this.swiperInstances.push(swiper.swiperInstance);
            } else if (window.innerWidth > 999 && swiper.swiperInstance) {
                swiper.swiperInstance.destroy();
                swiper.swiperInstance = null;
                this.swiperInstances = this.swiperInstances.filter(instance => instance !== swiper.swiperInstance);
            }

        } else {
            swiper.swiperInstance = new Swiper(swiper, {
                slidesPerView: swiper.getAttribute('slides-per-view') || 1,
                loop: true,
                pagination: {
                    el: '.swiper-pagination',
                    clickable: true,
                },
            });
            this.swiperInstances.push(swiper.swiperInstance);
        }
    }

    _handleResize() {
        this.swipers.forEach(swiper => {
            this._initSwiper(swiper);
        });
    }
}

window.customElements.define('swiper-component', SwiperComponent);
